export const commaSeparator = (value: number | string) => Number(value).toLocaleString('en-US');
